import { mapGetters } from "vuex";

import ClicRDV 					from "@/services/ClicRDV";
import { AUTH_LOGOUT } 	from "@/store/types";

const name = "LeftSidebar";

const data = () => ({
	pingIntervalId: null
});

const signOut = function () {
	this.$store.dispatch(AUTH_LOGOUT)
		.then(() => {
			this.$router.push("/session");
		});
};

const pingApi = function () {
	ClicRDV.getPing()
		.then(server => { this.$store.commit("ping", server); })
		.catch(() => {
			this.$store.commit("ping", {
				status: "KO",
				success: false,
				time: "API DOWN"
			});
		});
};

export default {
	name,
	data,
	mounted() {
		this.pingApi();

		this.pingIntervalId = setInterval(this.pingApi, 30000); // 30 seconds
	},
	beforeDestroy() {
		clearInterval(this.pingIntervalId);
	},
	methods: {
		signOut,
		pingApi,
		...mapGetters(["isAdmin"])
	}
};